import { NAV_SECTIONS } from "../../constants/navigation";
import { useSiteNavScroll } from "../../hooks/useSiteNavScroll";
import "../../styles/site_nav.css";

export default function SiteNav() {
  const { scrolled, activeId } = useSiteNavScroll(NAV_SECTIONS);

  return (
    <header
      className={`site-nav ${scrolled ? "site-nav--scrolled" : ""}`}
      role="banner"
    >
      <nav className="site-nav__links" aria-label="Page sections">
        {NAV_SECTIONS.map(({ href, id, label }) => (
          <a
            key={href}
            href={href}
            className={`site-nav__link${
              activeId === id ? " site-nav__link--active" : ""
            }`}
            aria-current={activeId === id ? "location" : undefined}
          >
            {label}
          </a>
        ))}
      </nav>
    </header>
  );
}
